import { FC, useRef } from 'react';

import MaterialIcon from '../../../../components/MaterialIcon/MaterialIcon';
import styles from './PhotoPicker.module.scss';
import Thumbnails from './Thumbnails';
import { PhotoPickerProps, usePhotoPicker } from './usePhotoPicker';

const DefaultPhotoPicker: FC<PhotoPickerProps> = (props) => {
  const { t, processingCount, errorMessage, previews, isFull, handleFiles, handleRemove } =
    usePhotoPicker(props);
  const cameraInputRef = useRef<HTMLInputElement>(null);

  const handleAddClick = () => {
    cameraInputRef.current?.click();
  };

  return (
    <div className={styles.picker}>
      <div className={styles.grid}>
        <Thumbnails
          onRemove={handleRemove}
          previews={previews}
          processingCount={processingCount}
          removeLabel={t('meterkast:removePhoto')}
        />

        {!isFull && (
          <button className={styles.addBtn} onClick={handleAddClick} type="button">
            <MaterialIcon name="photo_camera" size={28} />
            <span>{t('meterkast:addPhoto')}</span>
          </button>
        )}
      </div>

      {errorMessage && <p className={styles.error}>{errorMessage}</p>}

      <input
        accept="image/*"
        capture="environment"
        className={styles.hiddenInput}
        multiple
        onChange={handleFiles}
        ref={cameraInputRef}
        type="file"
      />
    </div>
  );
};

export default DefaultPhotoPicker;
